import { Form, Select } from "antd";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import styled from "styled-components";

export const Styles = styled.div`
  .inner {
    display: flex;
    flex-direction: column;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 0px;
      .left-handle {
        display: flex;
        align-items: center;
        svg {
          margin: 0px 10px;
        }
      }
    }
  }
`;

const FieldMappings = () => {
  return (
    <Styles>
      <div>フィルード連携</div>
      <Form.List name="field_mappings" initialValue={[{}]}>
        {(fields: any[], { add, remove }: any) => (
          <div className="inner">
            {fields.map(({ key, ...restField }, index) => (
              <div className="item" key={key}>
                <div className="left-handle">
                  <Select style={{ width: 300 }} />
                  <FaArrowAltCircleLeft size={22} color="#ababab" />
                  <Select style={{ width: 300 }} />
                </div>
                <div>
                  <AiFillPlusCircle
                    color="#ababab"
                    size={18}
                    onClick={() => add("add", index)}
                  />
                  {fields.length !== 1 && (
                    <AiFillMinusCircle
                      color="#ababab"
                      size={18}
                      onClick={() => remove(index)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Form.List>
    </Styles>
  );
};

export default FieldMappings;
